import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { actions as filterOptionsActions } from 'redux/filterOptions';
import { Space, Button, Select, AutoComplete, Checkbox, Row, Col } from 'antd';
import OrangeIcon from 'assets/images/icons/Badge_yellow.svg';
import BronzeIcon from 'assets/images/icons/Badge_bronze.svg';
import SilverIcon from 'assets/images/icons/Badge_silver.svg';
import BlueIcon from 'assets/images/icons/Badge_blue.svg';
import GreenIcon from 'assets/images/icons/Badge_green.svg';
import ShieldNotverifiedIcon from 'assets/images/icons/notverified.svg';
import ShieldVerifiedIcon from 'assets/images/icons/verified-icon.svg';

function MultiSelectFilter({ setScrollToFirstRow, scrollToFirstRow, dataIndex, data, onFilterChange, handleReset, value, name, isStorage, isCodeBasedFilter, needSemiColan }) {
  const { confirm, clearFilters } = data;
  const dispatch = useDispatch();
  const filterOptions = useSelector((state) => state.filterOptions);
  const referenceData = useSelector((state) => state.referenceData);

  const getShield = (label) => {
    if (label?.includes('Yellow')) return OrangeIcon;
    if (label?.includes('Bronze')) return BronzeIcon;
    if (label?.includes('Silver')) return SilverIcon;
    if (label?.includes('Blue')) return BlueIcon;
    if (label?.includes('Green')) return GreenIcon;
    return ShieldNotverifiedIcon;
  };

  let valueArray = [];
  if (value != undefined && value != '') {
    if(needSemiColan){
      valueArray = value.split(';');
    }else{
      valueArray = value.split(',');
    }
  } else {
    valueArray = null;
  }
  const [checkboxValues, setCheckboxValues] = useState([]);

  let options = [];
  if (dataIndex) {
    if (dataIndex === 'preferred_blocked_enum' || dataIndex === 'preferred_blocked_code') {
      options = [
        { value: 1, text: 'Preferred' },
        { value: 2, text: 'Exclude Blocked' },
        { value: 3, text: 'Following' },
      ];
    }
    if(dataIndex === "agreement"){
      let optionsRaw = _.get(filterOptions, 'data.Agreement') || [];
      options = optionsRaw.map((data)=> {return {value: data.text, text: data.text}})
      // console.log("MYOPTIONS:", options);
    }
    if (dataIndex === 'delivery_allotment_status_enum_code' || dataIndex === 'stock_in_out_delivery_status_enum' || dataIndex === 'delivery_status') {
      options = _.get(filterOptions, 'data.delivery_allotment_status_enum') || [];
    }
    if (dataIndex === 'stock_in_out_type_code') {
          options = _.get(filterOptions, 'data.stock_in_out_type_enum') || [];
        }
    if (dataIndex === 'goods_services') {
      options = _.get(filterOptions, 'data.goods') || [];
    }
    if (dataIndex === 'type_of_user') {
      options = _.get(filterOptions, 'data.TypeOfIndividualEnum') || [];
    }
    if (dataIndex === 'business_type_enum') {
      options = _.get(filterOptions, 'data.BusinessTypeEnum') || [];
    }
    if (dataIndex === 'nature_of_business') {
      options = _.get(filterOptions, 'data.NatureOfBusinessEnum') || [];
    }
    if (dataIndex === 'subscription_plan') {
      options = _.get(filterOptions, 'data.subscriptionPlan') || [];
    }
    if (dataIndex === 'deal_status_enum_code' || dataIndex === 'deal_1_status_enum_code' || dataIndex === 'deal_2_status_enum' || dataIndex === 'processing_deal_status_enum_code') {
      options = _.get(filterOptions, 'data.deal_status_enum') || [];
    }
    if (dataIndex === 'ManualInvoiceGoodsServices') {
      options = _.get(filterOptions, 'data.ManualInvoiceGoodsServices') || [];
    }
    if (dataIndex === 'commodity_code') {
      options = _.get(filterOptions, 'data.commodity') || [];
    }
    if (dataIndex === 'commodity_residue_code' || dataIndex === 'commodity_residue_id') {
      options = _.get(filterOptions, 'data.commodityResidue') || [];
    }

    if (dataIndex === 'commodity_residue_master_code' || dataIndex === 'commodity_residue_code') {
      options = _.get(filterOptions, 'data.commodityResidueMaster') || [];
    }
    if (dataIndex === 'kyc_status_enum_code') {
      options = _.get(filterOptions, 'data.kyc_status_enum') || [];
    }
    if (dataIndex === 'commodity_standard_enum_code' || dataIndex === 'grade' || dataIndex === 'commodity_standard') {
      // options = [
      //   { value: 1, text: 'Premium' },
      //   { value: 2, text: 'Superior' },
      //   { value: 3, text: 'Standard' },
      // ];
      options = _.get(filterOptions, 'data.CommodityStandardEnum') || [];
    }
    if (dataIndex === 'tick_color_enum_location') {
      options = _.get(filterOptions, 'data.tick_color_enum_location') || [];
      const priorityMap = {
        Green: 1,
        Blue: 2,
        Silver: 3,
        Bronze: 4,
        Yellow: 5,
        KYC: 6,
      };
      if(options){
        options = [...options].sort((a, b) => {
          const getPriority = (text) => {
            return (
              Object.entries(priorityMap).find(([key]) => text.includes(key))?.[1] ?? 999
            );
          };

          return getPriority(a.text) - getPriority(b.text);
        });
      }
    }
    if (dataIndex === 'address_type_enum_code') {
      options = _.get(filterOptions, 'data.AddressTypeEnum') || [];
    }
    if (dataIndex === 'slashing_progress_enum') {
      options = _.get(filterOptions, 'data.pickupActivityProgressEnum') || [];
    }
    if (dataIndex === 'shredding_progress_enum') {
      options = _.get(filterOptions, 'data.pickupActivityProgressEnum') || [];
    }
    if (dataIndex === 'raking_progress_enum') {
      options = _.get(filterOptions, 'data.pickupActivityProgressEnum') || [];
    }
    if (dataIndex === 'baling_progress_enum') {
      options = _.get(filterOptions, 'data.pickupActivityProgressEnum') || [];
    }
    if (dataIndex === 'tedding_progress_enum') {
      options = _.get(filterOptions, 'data.pickupActivityProgressEnum') || [];
    }
    if (dataIndex === 'pickup_progress_enum') {
      options = _.get(filterOptions, 'data.pickupActivityProgressEnum') || [];
    }
    if (dataIndex === 'offer_bid_type_enum') {
      options = [
        { value: -1, text: 'Quotation' },
        { value: 1, text: 'Offer' },
        { value: 2, text: 'Bid' },
      ];
    }
    if (dataIndex === 'transport_rate_status_enum_code') {
      options = _.get(filterOptions, 'data.TransportRateStatusEnum') || [];
    }
    if (dataIndex === 'MSME_Class_Code') {
      options = _.get(filterOptions, 'data.MSMEClassificationEnum') || [];
    }
    if (dataIndex === 'type_of_invoice') {
      options = _.get(filterOptions, 'data.settlement_invoice_type_enum') || [];
    }
    if(dataIndex === 'type_of_invoice_razorpay'){
      options =  [
        { value: 0, text: 'Advance Payment' },
        { value: 1, text: 'Aggregation Charges' },
        { value: 2, text: 'Assurance Services' },
        { value: 3, text: 'Commodity Invoice' },
        { value: 4, text: 'Credit Note' },
        { value: 5, text: 'Debit Note' },
        { value: 6, text: 'Delivery Challan' },
        { value: 7, text: 'Equipment Rent' },
        { value: 8, text: 'Platform Charges' },
        { value: 9, text: 'Processing Deals' },
        { value: 10, text: 'Qty Adjustment' },
        { value: 11, text: 'Quality Adjustment' },
        { value: 12, text: 'Reimbursement' },
        { value: 13, text: 'Subscription Charges' },
        { value: 14, text: 'Transport Invoice' },
        { value: 15, text: 'Transportation Charges' },
        { value: 16, text: 'Verification Charges' },
        { value: 17, text: 'Service Charges' },
      ];
    }
    if (dataIndex === 'settlement_invoice_type_code') {
      options = _.get(filterOptions, 'data.SettlementInvoiceType') || [];
    }
      if (dataIndex === 'req_offer_status_enum') {
      options = _.get(filterOptions, 'data.req_offer_status_enum') || [];
    }
      if (dataIndex === 'stock_transfer_status_enum') {
        options = _.get(filterOptions, 'data.StockTransferStatusEnum') || [];
      }
    if (dataIndex === 'settlement_invoice_category_code') {
      options = _.get(filterOptions, 'data.SettlementInvoiceCategory') || [];
    }
    if (dataIndex === 'eq_status') {
      options = _.get(filterOptions, 'data.EquipmentRentalTransactionsStatus') || [];
    }
    if (dataIndex === 'payment_term_id') {
      options = _.get(filterOptions, 'data.undefined') || [];
    }
    if (dataIndex === 'invoice_status_enum' || dataIndex === 'linked_invoicestatusenum' || dataIndex === 'invoice_status_enum_code') {
      options = _.get(filterOptions, 'data.invoice_status_enum') || [];
    }
    if (dataIndex === 'invoice_verification_enum' || dataIndex === 'workflow_invoice_verification_enum') {
      options = _.get(filterOptions, 'data.invoice_verification_enum') || [];
    }
    if (dataIndex === 'pg_payment_enum_code') {
      options = _.get(filterOptions, 'data.pg_payment_status_enum') || [];
    }
    if (dataIndex === 'equipment_type_id') {
      options = _.get(filterOptions, 'data.BF_SETUP_EQUIPMENT_TYPE') || [];
    }
    if (dataIndex === 'equipment_type_and_goods') {
      let equipmentTypeOptions = _.get(filterOptions, 'data.BF_SETUP_EQUIPMENT_TYPE') || [];
      let goodsOptions = _.get(filterOptions, 'data.goods') || [];
      options = [...equipmentTypeOptions, ...goodsOptions] || [];
    }
    useEffect(() => {
      if (value === undefined || value === null) {
        setCheckboxValues([])
      } else if (valueArray?.length) {
        setCheckboxValues(valueArray)
      }
    }, [value]);

    useEffect(() => {
      if (dataIndex !== '') {
        switch (dataIndex) {
          case 'delivery_allotment_status_enum_code':
          case 'stock_in_out_delivery_status_enum':
          case 'delivery_status':
            dispatch(filterOptionsActions.getDeliveryAllotmentStatusEnumData('delivery_allotment_status_enum'));
            break;
            case 'stock_in_out_type_code':
                     dispatch(filterOptionsActions.getstockInOutType());
                     break;
          case 'goods_services':
            dispatch(filterOptionsActions.getFilterDataByFilterEnum('goods'));
            break;
          case 'type_of_user':
            dispatch(filterOptionsActions.getRegisteredUserFilterData('TypeOfIndividualEnum'));
            break;
          case 'business_type_enum':
            dispatch(filterOptionsActions.getRegisteredUserFilterData('BusinessTypeEnum'));
            break;
          case 'nature_of_business':
            dispatch(filterOptionsActions.getRegisteredUserFilterData('NatureOfBusinessEnum'));
            break;
          case 'subscription_plan':
            dispatch(filterOptionsActions.getReferenceData('subscriptionPlan'));
            break;
          case 'ManualInvoiceGoodsServices':
            dispatch(filterOptionsActions.getFilterData('ManualInvoiceGoodsServices'));
            break;
          case 'commodity_code':
            dispatch(filterOptionsActions.getReferenceData('commodity'));
            break;
          case 'deal_status_enum_code':
            case 'deal_1_status_enum_code':
            case 'deal_2_status_enum':
            case 'processing_deal_status_enum_code':
              dispatch(filterOptionsActions.getDealEnumData(dataIndex));
              break;
          case 'commodity_residue_master_code':
          case 'commodity_residue_code':
            case 'commodity_residue_id':
              dispatch(filterOptionsActions.getReferenceData('commodityResidueMaster'));
              break;
          case 'kyc_status_enum_code':
            dispatch(filterOptionsActions.getKYCStatusEnumData('kycStatusEnum'));
            break;
          case 'stock_transfer_status_enum':
            dispatch(filterOptionsActions.getRegisteredUserFilterData('StockTransferStatusEnum'));
            break;
          case 'type_of_invoice':
            dispatch(filterOptionsActions.getTypeOfInvoiceEnumData('settlement_invoice_type_enum'));
            break;
          case 'address_type_enum_code':
            dispatch(filterOptionsActions.getRegisteredUserFilterData('AddressTypeEnum'));
            break;
            case 'slashing_progress_enum':
              dispatch(filterOptionsActions.getRegisteredUserFilterData('pickupActivityProgressEnum'));
              break;
              case 'shredding_progress_enum':
              dispatch(filterOptionsActions.getRegisteredUserFilterData('pickupActivityProgressEnum'));
              break;
              case 'raking_progress_enum':
                dispatch(filterOptionsActions.getRegisteredUserFilterData('pickupActivityProgressEnum'));
                break;
                case 'baling_progress_enum':
              dispatch(filterOptionsActions.getRegisteredUserFilterData('pickupActivityProgressEnum'));
              break;
              case 'tedding_progress_enum':
              dispatch(filterOptionsActions.getRegisteredUserFilterData('pickupActivityProgressEnum'));
              break;
              case 'pickup_progress_enum':
              dispatch(filterOptionsActions.getRegisteredUserFilterData('pickupActivityProgressEnum'));
              break;
          case 'commodity_standard_enum_code':
          case 'commodity_standard':
          case 'grade':
            dispatch(filterOptionsActions.getRegisteredUserFilterData('CommodityStandardEnum'));
            break;
          case 'transport_rate_status_enum_code':
            dispatch(filterOptionsActions.getRegisteredUserFilterData('TransportRateStatusEnum'));
            break;
          case 'MSME_Class_Code':
            dispatch(filterOptionsActions.getRegisteredUserFilterData('MSMEClassificationEnum'));
            break;
          case 'settlement_invoice_type_code':
            dispatch(filterOptionsActions.getFilterData('SettlementInvoiceType'));
            break;
          case 'req_offer_status_enum':
            dispatch(filterOptionsActions.getEnumData());
            break;
          case 'settlement_invoice_category_code':
            dispatch(filterOptionsActions.getFilterData('SettlementInvoiceCategory'));
            break;
          case 'eq_status':
            dispatch(filterOptionsActions.getFilterData('EquipmentRentalTransactionsStatus'));
            break;
          case 'agreement':
            dispatch(filterOptionsActions.getFilterDataELOC('Agreement'));
            break;
          case 'payment_term_id':
            dispatch(filterOptionsActions.getPaymentTermsForEquipment());
          case 'invoice_status_enum':
          case 'invoice_status_enum_code':
          case 'linked_invoicestatusenum':
            dispatch(filterOptionsActions.getInvoiceStatusEnumData('invoice_status_enum'));
            break;
          case 'workflow_invoice_verification_enum':
          case 'invoice_verification_enum':
            dispatch(filterOptionsActions.getInvoiceVerificationStatusEnumData('invoice_verification_enum'));
            break;
          case 'pg_payment_enum_code':
            dispatch(filterOptionsActions.getPgPaymentStatusEnum());
            break;
          case 'equipment_type_id':
            dispatch(filterOptionsActions.getRegisteredUserFilterData('BF_SETUP_EQUIPMENT_TYPE'));
            break;
          case 'equipment_type_and_goods':
            dispatch(filterOptionsActions.getRegisteredUserFilterData('BF_SETUP_EQUIPMENT_TYPE'));
            dispatch(filterOptionsActions.getFilterDataByFilterEnum('goods'));
            break;
          case 'tick_color_enum_location':
            dispatch(filterOptionsActions.extendedProfileVerificationStatusEnumData('tick_color_enum_location'));
            break;
        }
      }
    }, [dataIndex]);

    if (!_.isEmpty(options) && isStorage) {
      options = options.filter((item) => (item.text != "Closed") && (item.text != "CloseOut") && (item.text != "Rejected"))
    }

    return (
      <>
        <div
          className="p-10"
          // style={options?.length < 5 ? { display: 'inline-grid', width: '550px' } : { display: 'grid', width: '800px' }}
          style={{maxHeight: 300, overflow: 'auto'}}
        >
        <Checkbox.Group
            onChange={(e) => {
              setCheckboxValues(e);
            }}
            value={checkboxValues}
            // defaultValue={valueArray}
            loading={options?.length > 0 ? false : true}
            >
            <Col>
              {options?.map((option, index) => (
                <Row md={(dataIndex === 'payment_term_id' || dataIndex === 'agreement') ? 12 : 6}>
                  <Checkbox value={isCodeBasedFilter ? option.text.toString() : option.value.toString()}>
                    {dataIndex === 'tick_color_enum_location' && <img src={getShield(option?.text)} alt="" style={{height: '20px', width:'20px',marginRight:'10px'}}/>}
                    <span style={{ wordBreak: 'break-all' }}>{option.text}</span>
                  </Checkbox>
                </Row>
              ))}
            </Col>
          </Checkbox.Group>
        </div>
        <div className="pl-10 pr-10 pb-10">
          <Space className="mt-10">
            <Button
              onClick={() => {
                if (checkboxValues?.length) {
                  if(needSemiColan){
                    onFilterChange(checkboxValues.join(';'), dataIndex, confirm);
                  } else {
                    onFilterChange(checkboxValues.join(), dataIndex, confirm);
                  }
                  if (scrollToFirstRow) {
                    setScrollToFirstRow(true);
                  }
                } else {
                  handleReset(clearFilters, dataIndex);
                  setCheckboxValues([]);
                }
              }}
              size="small"
              type="primary"
              className="proceed-button w-100">
              Ok
            </Button>
            <Button
              className="reset-button"
              onClick={(e) => {
                // valueArray = [];
                handleReset(clearFilters, dataIndex);
                setCheckboxValues([]);
              }}
              size="small"
              style={{ width: 70, marginLeft: '5px' }}>
              Reset
            </Button>
          </Space>
        </div>
      </>
    );
  }
}

export default MultiSelectFilter;
